export default {"src":"/_next/static/media/file-input.68e97c16.svg","height":34,"width":33};